"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnapshotAbortController = void 0;
var _react = require("react");
var _uuid = require("uuid");
const flowIdToAbortController = new Map();
const issueToFlowIds = new Map();
class AbortError extends Error {
  constructor() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Operation was aborted.";
    super(message);
    this.name = "AbortError";
  }
}
const useSnapshotAbortController = () => {
  // Get the AbortController for a given flow
  const getAbortController = (0, _react.useCallback)(flowId => {
    return flowIdToAbortController.get(flowId);
  }, []);

  // Get a unique ID which represents a set of requests for a given issue
  // This is used to abort all requests for a given issue
  const getFlowId = (0, _react.useCallback)(issueId => {
    var _issueToFlowIds$get;
    const flowId = (0, _uuid.v4)();
    if (!issueToFlowIds.has(issueId)) {
      issueToFlowIds.set(issueId, new Set());
    }
    flowIdToAbortController.set(flowId, new AbortController());
    (_issueToFlowIds$get = issueToFlowIds.get(issueId)) === null || _issueToFlowIds$get === void 0 || _issueToFlowIds$get.add(flowId);
    return flowId;
  }, []);

  // Get the AbortSignal for a given flow
  const getSignal = (0, _react.useCallback)(flowId => {
    var _getAbortController;
    return (_getAbortController = getAbortController(flowId)) === null || _getAbortController === void 0 ? void 0 : _getAbortController.signal;
  }, [getAbortController]);

  // Throw an AbortError if the flow was aborted
  const throwIfAborted = (0, _react.useCallback)(flowId => {
    var _getAbortController2;
    return (_getAbortController2 = getAbortController(flowId)) === null || _getAbortController2 === void 0 ? void 0 : _getAbortController2.signal.throwIfAborted();
  }, [getAbortController]);

  // Check if the given error is an AbortError
  const isAbortError = (0, _react.useCallback)(e => {
    return typeof e === "object" && (e === null || e === void 0 ? void 0 : e.name) === "AbortError";
  }, []);

  // Abort all flows for a given issue, that were linked to the Issue by `getFlowId`
  const abortAllFlows = (0, _react.useCallback)(issueId => {
    const flowIds = issueToFlowIds.get(issueId);
    if (flowIds) {
      flowIds.forEach(flowId => {
        const abortController = flowIdToAbortController.get(flowId);
        if (abortController) {
          abortController.abort(new AbortError());
        }
      });
    }
  }, []);
  return {
    getFlowId,
    getSignal,
    throwIfAborted,
    abortAllFlows,
    isAbortError
  };
};
exports.useSnapshotAbortController = useSnapshotAbortController;
//# sourceMappingURL=useSnapshotAbortController.js.map